export enum ResponseStatus {
    ERROR = "ERROR",
    SUCESS = "SUCESS"
}

export class CreateSystempayPaymentResponse {
    status: ResponseStatus // SUCCESS
    _type: string
    webService: string // Charge/CreatePayment
    applicationProvider: string // NPS
    version: string // V4
    applicationVersion: string // 4.1.0
    answer: {
        formToken: string,
        _type: string, // V4/Charge/PaymentForm
        detailedErrorMessage?: string
    }
    constructor(
        status: ResponseStatus, // SUCCESS
        _type: string,
        webService: string, // Charge/CreatePayment
        applicationProvider: string, // NPS
        version: string, // V4
        applicationVersion: string, // 4.1.0
        answer: {
            formToken: string,
            _type: string, // V4/Charge/PaymentForm
            detailedErrorMessage?: string
        }
    ) {
        this.status = status
        this._type = _type
        this.webService = webService
        this.applicationProvider = applicationProvider
        this.version = version
        this.applicationVersion = applicationVersion
        this.answer = answer
    }
}